import { render } from "./ActionResponseBox.vue?vue&type=template&id=a3b350d0"
import script from "./ActionResponseBox.vue?vue&type=script&lang=js"
export * from "./ActionResponseBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__